import React from 'react';

const NODE_LABELS = {
  asktextnode: 'Text', numbernode: 'Number', phonenode: 'Phone',
  emailnode: 'Email', datenode: 'Date', locnode: 'Location',
  urlnode: 'URL', filenode: 'File',
};

const FALLBACK_VARS = {
  common: ['name', 'phone_no', 'email', 'customer_id', 'address'],
  banking: ['account_no', 'transaction_id', 'loan_id', 'card_no', 'amount'],
  healthcare: ['patient_id', 'appointment_id', 'doctor_name'],
  education: ['student_id', 'course_id', 'grade'],
  ecommerce: ['product_id', 'order_id', 'payment_method'],
};

export default function AskTextEditor({ value, onChange, nodeType }) {
  const label = NODE_LABELS[nodeType] || 'Text';
  const v = value || {};
  const validation = v.validation || {};

  const upd    = (key, val) => onChange({ ...v, [key]: val });
  const updVal = (key, val) => onChange({ ...v, validation: { ...validation, [key]: val } });

  const allVars = Object.values(FALLBACK_VARS).flat();

  // Only fix: add color:#0f172a to all inputs so text is visible
  const inputStyle = { width:'100%', padding:'6px 8px', border:'1px solid #e2e8f0', borderRadius:6, fontSize:12, color:'#0f172a', outline:'none', boxSizing:'border-box' };

  return (
    <div style={{ padding:16, display:'flex', flexDirection:'column', gap:14 }}>
      <div>
        <label style={{ fontSize:11, fontWeight:700, color:'#475569', display:'block', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.06em' }}>{label} Question</label>
        <textarea
          value={v.text || ''}
          onChange={e => upd('text', e.target.value)}
          onKeyDown={e => e.stopPropagation()}
          placeholder={`What would you like to ask for ${label.toLowerCase()}?`}
          rows={3}
          style={{ width:'100%', padding:'8px 10px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:12, color:'#0f172a', resize:'vertical', outline:'none', boxSizing:'border-box', fontFamily:'inherit' }}
        />
      </div>

      <div>
        <label style={{ fontSize:11, fontWeight:700, color:'#475569', display:'block', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.06em' }}>Store in Variable</label>
        <input
          value={v.variable || ''}
          onChange={e => upd('variable', e.target.value.toLowerCase().replace(/\s+/g, '_'))}
          onKeyDown={e => e.stopPropagation()}
          placeholder="variable_name"
          style={{ width:'100%', padding:'8px 10px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:12, fontFamily:'monospace', color:'#4f46e5', outline:'none', boxSizing:'border-box' }}
        />
        <div style={{ display:'flex', flexWrap:'wrap', gap:4, marginTop:6 }}>
          {allVars.slice(0, 8).map(vr => (
            <button key={vr} onClick={() => upd('variable', vr)}
              style={{ padding:'2px 8px', fontSize:10, fontFamily:'monospace', background:'#f1f5f9', border:'1px solid #e2e8f0', borderRadius:10, cursor:'pointer', color:'#475569' }}>
              {vr}
            </button>
          ))}
        </div>
      </div>

      <div style={{ background:'#f8fafc', borderRadius:8, padding:12, border:'1px solid #e2e8f0' }}>
        <p style={{ fontSize:11, fontWeight:700, color:'#475569', marginBottom:10, textTransform:'uppercase', letterSpacing:'0.06em' }}>Validation</p>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
          <div>
            <label style={{ fontSize:10, color:'#94a3b8', display:'block', marginBottom:4 }}>Max Attempts</label>
            <input type="number" min={1} max={5}
              value={validation.attempts || 1}
              onChange={e => updVal('attempts', parseInt(e.target.value) || 1)}
              style={inputStyle}/>
          </div>
          <div>
            <label style={{ fontSize:10, color:'#94a3b8', display:'block', marginBottom:4 }}>On Invalid</label>
            <select value={validation.actionOnInvalid || 'skip'}
              onChange={e => updVal('actionOnInvalid', e.target.value)}
              style={inputStyle}>
              <option value="skip">Skip</option>
              <option value="retry">Retry</option>
              <option value="end">End</option>
            </select>
          </div>
          {nodeType !== 'locnode' && nodeType !== 'filenode' && <>
          <div>
            <label style={{ fontSize:10, color:'#94a3b8', display:'block', marginBottom:4 }}>Min Length</label>
            <input value={validation.minLength || ''}
              onChange={e => updVal('minLength', e.target.value)}
              onKeyDown={e => e.stopPropagation()}
              placeholder="e.g. 2"
              style={inputStyle}/>
          </div>
          <div>
            <label style={{ fontSize:10, color:'#94a3b8', display:'block', marginBottom:4 }}>Max Length</label>
            <input value={validation.maxLength || ''}
              onChange={e => updVal('maxLength', e.target.value)}
              onKeyDown={e => e.stopPropagation()}
              placeholder="e.g. 100"
              style={inputStyle}/>
          </div>
          </>}
        </div>
        {nodeType !== 'locnode' && nodeType !== 'filenode' && (
        <div style={{ marginTop:8 }}>
          <label style={{ fontSize:10, color:'#94a3b8', display:'block', marginBottom:4 }}>Regex Pattern (optional)</label>
          <input value={validation.regex || ''}
            onChange={e => updVal('regex', e.target.value)}
            onKeyDown={e => e.stopPropagation()}
            placeholder="e.g. ^[0-9]{10}$"
            style={{ ...inputStyle, fontFamily:'monospace', fontSize:11 }}/>
        </div>
        )}
        <div style={{ marginTop:8 }}>
          <label style={{ fontSize:10, color:'#94a3b8', display:'block', marginBottom:4 }}>Error Message</label>
          <input value={validation.errMessage || ''}
            onChange={e => updVal('errMessage', e.target.value)}
            onKeyDown={e => e.stopPropagation()}
            placeholder="Please enter a valid value."
            style={inputStyle}/>
        </div>
      </div>
    </div>
  );
}
